import request from '@/router/axios'

export function fetchTrainingCourseStatisticsSummary (params) {
  return request({
    url: '/activity/admin/activity/projects/analysis/summary/training-course',
    method: 'get',
    params,
  })
}

export function exportTrainingCourseStatisticsSummary (params) {
  return request({
    url: '/activity/admin/activity/projects/analysis/summary/training-course/export',
    method: 'get',
    params,
  })
}

export function fetchTrainingUserStatisticsSummary (params) {
  return request({
    url: '/activity/admin/activity/projects/analysis/summary/training-user',
    method: 'get',
    params,
  })
}

export function exportTrainingUserStatisticsSummary (params) {
  return request({
    url: '/activity/admin/activity/projects/analysis/summary/training-user/export',
    method: 'get',
    params,
  })
}

export function fetchTrainingCategoryStatisticsSummary (params) {
  return request({
    url: '/activity/admin/activity/projects/analysis/summary/training-category',
    method: 'get',
    params,
  })
}

export function exportTrainingCategoryStatisticsSummary (params) {
  return request({
    url: '/activity/admin/activity/projects/analysis/summary/training-category/export',
    method: 'get',
    params,
  })
}
